module.exports = __webpack_public_path__ + "img/Contact.8cfb5757.png";